import {Component, HostListener} from '@angular/core';
import {AuthenticationService} from "../services/authentication.service";
import {RegistrationService} from "../services/registration.service";
import {User} from "../models/user";
import {EventService} from "../services/event.service";
import {Router} from "@angular/router";
import {OrganizationService} from "../services/organization.service";
import {forkJoin, map, mergeMap} from "rxjs";
import {Event} from "../models/event";

@Component({
    selector: 'app-profile-events-overview',
    templateUrl: './profile-events-overview.component.html',
    styleUrls: ['./profile-events-overview.component.css'],
    standalone: false
})
export class ProfileEventsOverviewComponent {
  user!: User;
  events!: any[];

  searchTerm = "";
  eventTypeArray: string[] = [];
  disabilityArray: string[] = [];

  screen_width!: number;
  hide_small!: boolean;

  constructor(
    public orgService: OrganizationService,
    private authService: AuthenticationService,
    private regService: RegistrationService,
    private eventService: EventService,
    private router: Router
  ) {}

  async ngOnInit() {
    this.user = await this.authService.getUser();

    this.regService.getRegistrationsByUser(this.user.uid).subscribe(
      regs => {
        forkJoin(
          regs.map(reg =>
            this.eventService.getEventByRef(reg.event.path).pipe(
              mergeMap(event =>
                this.orgService.getOrganizationByRef(event.organization).pipe(
                  map(orgDetails => ({ ...event, orgDetails }))
                )
              )
            )
          )
        ).subscribe(
          transformedEvents => {
            this.events = transformedEvents;
          }
        );
      }
    );

    this.onResize();
  }

  onInputValuesChange(emitValues: { inputValue: string, eventTypeArray: string[], disabilityArray: string[] }) {
    this.searchTerm = emitValues.inputValue;
    this.eventTypeArray = emitValues.eventTypeArray;
    this.disabilityArray = emitValues.disabilityArray;
  }

  redirectToEvent(eventID: string) {
    this.router.navigate([`/activiteit/${eventID}`]);
  }

  /**
   * Combines the category filter and disability filter for readability
   */
  getFilteredEvents(): any[] {
    const filteredByName = this.nameFilter(this.events);
    const filteredByCategory = this.categoryFilter(filteredByName);
    return this.disabilityFilter(filteredByCategory);
  }

  /**
   * Filters the events based on the searchterm used in the filter
   *
   * @param events
   */
  nameFilter(events: any[]) {
    if (this.searchTerm != undefined) {
      return events.filter(event => event.name.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1);
    } else {
      return events;
    }
  }

  /**
   * Filters the events based on the category checkboxes
   *
   * @param events
   */
  categoryFilter(events: any[]) {
    if (this.eventTypeArray.length > 0) {
      return events.filter(event => this.eventTypeArray.includes(event.category.toLowerCase()));
    } else {
      return events;
    }
  }

  /**
   * Filters the events based on the disability checkboxes
   *
   * @param events
   */
  disabilityFilter(events: any[]) {
    if (this.disabilityArray.length > 0) {
      return events.filter(event =>
        this.disabilityArray.some(disability => event.accessibility[disability])
      );
    } else {
      return events;
    }
  }

  /**
   * Checks if the event dates are on the same day and month
   *
   * @return Boolean
   */
  eventDateTime(event: Event): Boolean {
    return event.start.toDate().getMonth() != event.end.toDate().getMonth() || event.start.toDate().getDay() != event.end.toDate().getDay();
  }

  /**
   * Checks if the window size corresponds to one of the size limits
   *
   * @param event
   */
  @HostListener('window:resize', ['$event'])
  onResize(event?: any) {
    this.screen_width = window.innerWidth;
    this.hide_small = this.screen_width <= 1500;
  }
}
